(function ($) {
	// On Dom Ready
	$(function () {
		// === Filter Team Members ===
		var filters_data = {};
		var search_form_selector = ".search-form.team-search-form";

		// on form submission
		$(search_form_selector).on("submit", function (e) {
			e.preventDefault();

			if ($("#search_keyword").val()) {
				filters_data.keyword = $("#search_keyword").val();
			} else {
				delete filters_data.keyword;
			}

			filter_team_members();
		});

		// on filters change
		$(search_form_selector)
			.find(
				"#filter_title, #filter_office, #filter_law_school, #filter_service, #filter_industry"
			)
			.on("change", function (e) {
				e.preventDefault();
				$(search_form_selector).submit();
			});

		// on alphabet click
		$(document).on("click", "a.first-letter-link", function (e) {
			e.preventDefault();
			filters_data.first_letter = $(this).data("first_letter");
			$(".first-letter-link").removeClass("active");
			$(this).addClass("active");
			filter_team_members();
		});

		// clear search
		$(search_form_selector)
			.find(".btn-clear-search")
			.on("click", function (e) {
				e.preventDefault();
				$("#search_keyword").val("");
				delete filters_data.keyword;
				filter_team_members();
			});

		// clear filters
		$(search_form_selector)
			.find(".clear-filters")
			.on("click", function (e) {
				e.preventDefault();

				$(search_form_selector).trigger("reset");

				$("select", search_form_selector)
					.prop("selectedIndex", 0)
					.selectric("refresh");

				$(".first-letter-link").removeClass("active");

				filters_data = {};

				filter_team_members();

				$(document.body).trigger("team-filters-cleared");
			});

		// things to do after filters updated
		$(document.body).on("team-filters-updated", function (e) {
			e.preventDefault();
			console.log("team filters updated");

			// generate url & update it
			var url = new URL($("#base_url").val());
			window.history.replaceState({}, "", url.href);

			if (Object.keys(filters_data).length > 0) {
				// loop through each filter
				for (const [key, value] of Object.entries(filters_data)) {
					url.searchParams.set(key, value);
				}

				window.history.replaceState({}, "", url.href);
			}

			// show/hide clear filters button
			if (Object.keys(filters_data).length > 0) {
				$(".clear-filters-wrapper").addClass("active");
			} else {
				$(".clear-filters-wrapper").removeClass("active");
			}
		});

		// things to do after filters cleared
		$(document.body).on("team-filters-cleared", function (e) {
			e.preventDefault();
			console.log("team filters cleared");
		});

		// common function to filter team members
		function filter_team_members() {
			if ($("#filter_title").val()) {
				filters_data.filter_title = $("#filter_title").val();
			} else {
				delete filters_data.filter_title;
			}

			if ($("#filter_office").val()) {
				filters_data.filter_office = $("#filter_office").val();
			} else {
				delete filters_data.filter_office;
			}

			if ($("#filter_law_school").val()) {
				filters_data.filter_law_school = $("#filter_law_school").val();
			} else {
				delete filters_data.filter_law_school;
			}

			if ($("#filter_service").val()) {
				filters_data.filter_service = $("#filter_service").val();
			} else {
				delete filters_data.filter_service;
			}

			if ($("#filter_industry").val()) {
				filters_data.filter_industry = $("#filter_industry").val();
			} else {
				delete filters_data.filter_industry;
			}

			// show/hide clear search button
			if ($("#search_keyword").val()) {
				$(".keyword-wrapper").addClass("active");
			} else {
				$(".keyword-wrapper").removeClass("active");
			}

			console.log(filters_data);

			// ajax request
			var data = {
				action: "filter_team_members",
				security: js_params.ajax_nonce,
				...filters_data,
			};

			var listing_element = $(".team-member-list-wrapper");

			$.ajax({
				url: js_params.ajaxurl,
				data: data,
				type: "POST",
				beforeSend: function (xhr) {
					listing_element.append(
						'<div class="loading"><div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>'
					);
				},
				success: function (data) {
					if (data) {
						listing_element.html(data);
						$(document.body).trigger("team-filters-updated");
					}
				},
			});
		}
	});
})(jQuery);
